// extracted by mini-css-extract-plugin
export default {"wrapper":"bfA9wx","item":"dqBs8e"};